<template>
  <div id="MainWrapper">
     <rwv-Subbanner :title="title" :tag="tag" :banner="banner"></rwv-Subbanner> 
     <section class="padd-tb55">
       <div class="container">
         <div class="row">
           <div class="col-md-5 inline-block verticle-top aos-init aos-animate" data-aos="fade-in" data-aos-duration="550" data-aos-delay="1000">
             <div class="lpe_">
                <h2 class="blue-c-2 ubuntu font-bold mar-no ">Need to talk to us?</h2>
                <h6 class="blue-c-2 ubuntu font-light padd-b40">Ready to take it a step further?</h6>
                <p class="blue-c-2 ubuntu small-p font-light padd-b40">Let's start talking about how you can invest with Dan Advance.</p>
                <address class="le_">
                      <label class="ubuntu font-light blue-c-2">Call Us on</label>
                      <a href="tel:+1 877-227-4060" class="ubuntu blue-c-2">+1 877-227-4060</a>
                </address>
                <address>
                  <label class="ubuntu font-light blue-c-2">Write to us</label>
                  <a href="mailto:info@danadvance.com" class="ubuntu blue-c-2">info@danadvance.com</a>
                </address>
              </div>
           </div><div id="ContactFormWrap" class="col-md-7 inline-block verticle-top aos-init aos-animate" data-aos="fade-in" data-aos-duration="550" data-aos-delay="1200">
                  <form name="contactForm" id="contactForm"  @submit.prevent="processForm" >
                    <div class="row">
                        <div class="col-sm-12">
                          <div id="form-result"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</span>
                            <input type="text" name="first_name" id="first_name" placeholder=" " v-model="first_name" v-validate="'required'" >
                            <label for="first_name">First Name *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</span>
                            <input type="text" name="last_name" id="last_name" placeholder=" " v-model="last_name" v-validate="'required'" >
                            <label for="last_name">Last Name *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('company')" class="help is-danger">{{ errors.first('company') }}</span>
                            <input type="text" name="company" id="company" placeholder=" " v-model="company" v-validate="'required'" >
                            <label for="company">Company *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('designation')" class="help is-danger">{{ errors.first('designation') }}</span>
                            <input type="text" name="designation" id="designation" placeholder=" " v-model="designation" v-validate="'required'" >
                            <label for="designation">Role/Designation *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                            <input type="email" name="email" id="email" placeholder=" " v-model="email" v-validate="'required|email'" >
                            <label for="email">Email *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
                            <input type="tel" name="phone" id="phone" placeholder=" " v-model="phone" v-validate="'required|numeric'" >
                            <label for="phone">Phone *</label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="field">
                            <textarea name="message" id="message" placeholder=" " rows="4"></textarea>
                            <label for="message">How can we help you?</label>
                          </div>
                        </div>


                        <div class="col-sm-12">
                          <div class="padd-tb15">
                            <label class="container_l ubuntu big">Subscribe to our newsletter<input type="checkbox" checked="checked" id="newsletter" name="newsletter" value="1"><span class="checkmark"></span></label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                           <div class="padd-tb15">
                            <vue-recaptcha sitekey="6LcVxrEUAAAAADs2q17NSpuTo9YEMI361EVDCW3J"  :loadRecaptchaScript="true"></vue-recaptcha>
                           </div>
                        </div>


                        <div class="col-sm-6">
                          <div class="padd-tb15">
                            <button class="" id="SubmitContact">Submit</button>
                          </div>
                        </div>

                      </div>
                  </form>
                </div>
          </div>
       </div>
     </section>
  </div> 
</template>

<script>
import * as $ from 'jquery'
import 'paroller.js';
import RwvSubbanner from '@/components/Subbanner'
import VueRecaptcha from 'vue-recaptcha';

import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
export default {
  name: 'Home',
  data: function() {
    return {
      title: 'Contact <br> Dan Advance',
      tag:'More than just a reliable rate of return!',
      banner:require('./../../static/images/banner/contact.jpg'),
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      company: '',
      designation: ''
    }
  },
  mounted() {
    
  },
  components: { RwvSubbanner, VueRecaptcha },
  methods: {
    processForm: function() {
      //console.log({ name: this.name, email: this.email });
      //alert('Processing!');

        this.$validator.validateAll().then((result) => {
        if (result) {
            //alert("success");
      
              //replace submit button with loader
              $( "#SubmitContact" ).fadeOut('fast', function(){
                  $( '<img src="'+ require('./../../static/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
              });

              // Send the data using post
              var form = $( "#contactForm" );  
              var posting = $.post('https://danadvance.com/investor/ajax/contact.php', form.serialize() );

              // Put the results in a div
              posting.done(function( data ) {
                var obj = $.parseJSON(data);
                $( "#form-result" ).empty().append( obj.msg );
                if(obj.success == 'true')
                {
                  //success
                  form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                }
                $( "#SubmitContact" ).fadeIn('fast', function(){
                  $( '#loader_gif' ).remove();
                  grecaptcha.reset();
                });
              });

        }
        });      

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Contact.vue